module.exports = "../img/weber-shaping-ideas-2d9U7bX.svg";